/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/033-books': {
    width: 18,
    height: 16,
    viewBox: '0 0 18 16',
    data: '<path pid="0" d="M3.5 2h-3c-.275 0-.5.225-.5.5v11c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-11c0-.275-.225-.5-.5-.5zM3 5H1V4h2v1zM8.5 2h-3c-.275 0-.5.225-.5.5v11c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-11c0-.275-.225-.5-.5-.5zM8 5H6V4h2v1z"/><path pid="1" d="M11.954 2.773l-2.679 1.35a.502.502 0 00-.222.671l4.5 8.93a.502.502 0 00.671.222l2.679-1.35a.502.502 0 00.222-.671l-4.5-8.93a.502.502 0 00-.671-.222z"/><path pid="2" d="M14.5 13.5a.5.5 0 11-1 0 .5.5 0 011 0z"/>'
  }
})
